import { createAction } from "@reduxjs/toolkit";
import {
    COMPARING_SCENARIO_CHART_DATA_RECEIVED,
    COMPARING_SCENARIO_MAP_DATA_RECEIVED,
    DEMAND_CHART_DATA_RECEIVED,
    DEMAND_FILTERS_RECEIVED,
    DWELL_TIME_DATA_RECEIVED,
    GET_AGGREGATED_DEMAND_MAP_DATA,
    GET_AGGREGATED_DWELL_TIME_DATA,
    GET_COMPARING_SCENARIO_CHART_DATA,
    GET_COMPARING_SCENARIO_MAP_DATA,
    GET_DEMAND_CHART_AGGREGATE_DATA,
    GET_DEMAND_CHART_DATA,
    GET_DEMAND_FILTERS,
    GET_DWELL_TIME_DATA,
    GET_MAP_DATA,
    GET_SUPPLY_CHART_DATA,
    GET_SUPPLY_FILTERS,
    HIGHLIGHTED_DASHBOARD_LINKS,
    MAP_DATA_RECEIVED,
    SET_ACTIVE_DASHBOARD,
    SET_COMPARISON_SUMMARY_STATS_DATA,
    SET_DEMAND_SUMMARY_STATS_DATA,
    SET_LEGENDS,
    SET_SELECTED_SUPPLY_BAR_CHART_DATA,
    SET_SUPPLY_API_PARAMS,
    SET_SUPPLY_NON_API_PARAMS,
    SET_SUPPLY_SUMMARY_STATUS_DATA,
    STORE_DEMAND_FILTERS_FORM_VALUES,
    SUPPLY_CHART_DATA_RECEIVED,
    SUPPLY_FILTERS_RECEIVED,
    UPDATE_MAP_DATA_SLAVE,
    ComparingScenarioChartDataReceivedAction,
    ComparingScenarioDataReceivedAction,
    DemandChartDataReceivedAction,
    DemandFiltersReceivedAction,
    DwellTimeDataReceivedAction,
    GetAggregatedDemandMapDataAction,
    GetAggregatedDwellTimeDataAction,
    GetComparingScenarioChartDataAction,
    GetComparingScenarioDataAction,
    GetDemandChartAggregateDataAction,
    GetDemandChartDataAction,
    GetDwellTimeDataAction,
    GetSupplyChartDataAction,
    GetSupplyMapDataAction,
    HighlightedDashboardLinksAction,
    SetActiveDashboardAction,
    SetComparisonSummaryStatsDataAction,
    SetDemandSummaryStatsDataAction,
    SetLegendsAction,
    SetSelectedSupplyBarChartDataAction,
    SetGenericNonAPIParamsAction,
    SetGenericAPIParamsAction,
    SetSupplySummaryStatusDataAction,
    StoreDemandFilterFormValuesAction,
    SupplyChartDataReceivedAction,
    SupplyFiltersReceivedAction,
    SupplyMapDataReceivedAction,
    UpdateSupplyMapDataSlaveAction,
    SET_COMPARISON_API_PARAMS,
    SET_COMPARISON_NON_API_PARAMS,
    SET_DEMAND_COMPARISON_NON_API_PARAMS,
    GET_HISTORICAL_OCCUPANCY,
    GetHistoricalOccupancy,
    HISTORICAL_OCCUPANCY_RECEIVED,
    HistoricalOccupancyReceived,
    SELECTED_HISTORICAL_OCCUPANCY_RANGE,
    SelectedHistoricalOccupancyRange,
    TOGGLE_HISTORICAL_OCCUPANCY,
    ToggleHistoricalOccupancy,
    StoreDemandComparisonAPIParamsAction,
    STORE_DEMAND_COMPARISON_API_PARAMS,
    DemandComparisonChartDataReceivedAction,
    DEMAND_COMPARISON_CHART_DATA_RECEIVED,
    ComparisonDwellTimeDataReceivedAction,
    COMPARISON_DWELL_TIME_DATA_RECEIVED,
    StoreExportSupplyChartDataAction,
    STORE_EXPORT_SUPPLY_CHART_DATA,
    STORE_CHART_DATA,
    ExportChartDataAction,
    DownloadExportedFileAction,
    DOWNLOAD_EXPORTED_FILE,
    GET_AVERAGE_OCCUPANCY_PERCENT,
    GetAverageOccupancyPercent,
    SetChartLegendsAction,
    SET_CHART_LEGENDS,
    GetDemandSessionDataAction,
    DemandSessionDataReceivedAction,
    GET_DEMAND_SESSION_DATA,
    DEMAND_SESSION_DATA_RECEIVED,
    DEMAND_COMPARISON_SESSION_DATA_RECEIVED,
    DemandComparisonSessionDataReceivedAction,
    GetDemandSessionAggregateDataAction,
    GET_DEMAND_SESSION_AGGREGATE_DATA,
    GET_DEMAND_COMPARISON_CHART_DATA,
    GetDemandComparisonChartDataAction,
    GET_DEMAND_COMPARISON_CHART_AGGREGATE_DATA,
    GetDemandComparisonChartAggregateDataAction,
    GET_DEMAND_COMPARISON_SESSION_AGGREGATE_DATA,
    GET_DEMAND_COMPARISON_SESSION_DATA,
    GetDemandComparisonSessionAggregateDataAction,
    GetDemandComparisonSessionDataAction
} from "./types";
import { createOptionalAction } from "actions/helper";

export const getSupplyFilters = createAction(GET_SUPPLY_FILTERS);

export const storeExportChartData =
    createOptionalAction<ExportChartDataAction["payload"]>(STORE_CHART_DATA);

export const supplyFiltersReceived =
    createAction<SupplyFiltersReceivedAction["payload"]>(SUPPLY_FILTERS_RECEIVED);

export const getMapData = createAction<GetSupplyMapDataAction["payload"]>(GET_MAP_DATA);

export const mapDataReceived =
    createAction<SupplyMapDataReceivedAction["payload"]>(MAP_DATA_RECEIVED);

export const getSupplyChartData =
    createAction<GetSupplyChartDataAction["payload"]>(GET_SUPPLY_CHART_DATA);

export const supplyChartDataReceived = createAction<SupplyChartDataReceivedAction["payload"]>(
    SUPPLY_CHART_DATA_RECEIVED
);

export const storeExportSupplyChartData = createAction<StoreExportSupplyChartDataAction["payload"]>(
    STORE_EXPORT_SUPPLY_CHART_DATA
);

export const downloadExportedFile =
    createAction<DownloadExportedFileAction["payload"]>(DOWNLOAD_EXPORTED_FILE);

export const getDemandChartData =
    createAction<GetDemandChartDataAction["payload"]>(GET_DEMAND_CHART_DATA);

export const getDemandComparisonChartData = createAction<
    GetDemandComparisonChartDataAction["payload"]
>(GET_DEMAND_COMPARISON_CHART_DATA);

export const demandChartDataReceived = createAction<DemandChartDataReceivedAction["payload"]>(
    DEMAND_CHART_DATA_RECEIVED
);

export const demandComparisonChartDataReceived = createAction<
    DemandComparisonChartDataReceivedAction["payload"]
>(DEMAND_COMPARISON_CHART_DATA_RECEIVED);

export const setSupplyAPIParams =
    createAction<SetGenericAPIParamsAction["payload"]>(SET_SUPPLY_API_PARAMS);

export const setComparisonAPIParams =
    createAction<SetGenericAPIParamsAction["payload"]>(SET_COMPARISON_API_PARAMS);

export const setSupplyNonAPIParams =
    createAction<SetGenericNonAPIParamsAction["payload"]>(SET_SUPPLY_NON_API_PARAMS);

export const setComparisonNonAPIParams = createAction<SetGenericNonAPIParamsAction["payload"]>(
    SET_COMPARISON_NON_API_PARAMS
);

export const setDemandComparisonNonAPIParams = createAction<
    SetGenericNonAPIParamsAction["payload"]
>(SET_DEMAND_COMPARISON_NON_API_PARAMS);
export const updateMapDataSlave =
    createAction<UpdateSupplyMapDataSlaveAction["payload"]>(UPDATE_MAP_DATA_SLAVE);

export const highlightedDashboardLinks = createOptionalAction<
    HighlightedDashboardLinksAction["payload"]
>(HIGHLIGHTED_DASHBOARD_LINKS);

export const setLegends = createAction<SetLegendsAction["payload"]>(SET_LEGENDS);

export const setChartLegends = createAction<SetChartLegendsAction["payload"]>(SET_CHART_LEGENDS);

export const setSelectedSupplyBarChartData = createAction<
    SetSelectedSupplyBarChartDataAction["payload"]
>(SET_SELECTED_SUPPLY_BAR_CHART_DATA);

export const setSupplySummaryStatusData = createAction<SetSupplySummaryStatusDataAction["payload"]>(
    SET_SUPPLY_SUMMARY_STATUS_DATA
);

export const getDemandFilters = createAction(GET_DEMAND_FILTERS);

export const demandFiltersReceived =
    createAction<DemandFiltersReceivedAction["payload"]>(DEMAND_FILTERS_RECEIVED);

export const storeDemandFilterFormValues = createAction<
    StoreDemandFilterFormValuesAction["payload"]
>(STORE_DEMAND_FILTERS_FORM_VALUES);

export const storeDemandComparisonAPIParams = createAction<
    StoreDemandComparisonAPIParamsAction["payload"]
>(STORE_DEMAND_COMPARISON_API_PARAMS);

export const setActiveDashboard =
    createAction<SetActiveDashboardAction["payload"]>(SET_ACTIVE_DASHBOARD);

export const setDemandSummaryStatsData = createAction<SetDemandSummaryStatsDataAction["payload"]>(
    SET_DEMAND_SUMMARY_STATS_DATA
);

export const setComparisonSummaryStatsData = createAction<
    SetComparisonSummaryStatsDataAction["payload"]
>(SET_COMPARISON_SUMMARY_STATS_DATA);

export const getComparingScenarioMapData = createAction<GetComparingScenarioDataAction["payload"]>(
    GET_COMPARING_SCENARIO_MAP_DATA
);

export const comparingScenarioMapDataReceived = createAction<
    ComparingScenarioDataReceivedAction["payload"]
>(COMPARING_SCENARIO_MAP_DATA_RECEIVED);

export const getComparingScenarioChartData = createAction<
    GetComparingScenarioChartDataAction["payload"]
>(GET_COMPARING_SCENARIO_CHART_DATA);

export const comparingScenarioChartDataReceived = createAction<
    ComparingScenarioChartDataReceivedAction["payload"]
>(COMPARING_SCENARIO_CHART_DATA_RECEIVED);

export const getDwellTimeData =
    createAction<GetDwellTimeDataAction["payload"]>(GET_DWELL_TIME_DATA);

export const getDemandSessionData =
    createAction<GetDemandSessionDataAction["payload"]>(GET_DEMAND_SESSION_DATA);

export const getDemandSessionAggregateData = createAction<
    GetDemandSessionAggregateDataAction["payload"]
>(GET_DEMAND_SESSION_AGGREGATE_DATA);

export const getDemandComparisonSessionData = createAction<
    GetDemandComparisonSessionDataAction["payload"]
>(GET_DEMAND_COMPARISON_SESSION_DATA);

export const getDemandComparisonSessionAggregateData = createAction<
    GetDemandComparisonSessionAggregateDataAction["payload"]
>(GET_DEMAND_COMPARISON_SESSION_AGGREGATE_DATA);

export const demandSessionDataReceived = createAction<DemandSessionDataReceivedAction["payload"]>(
    DEMAND_SESSION_DATA_RECEIVED
);

export const demandComparisonSessionDataReceived = createAction<
    DemandComparisonSessionDataReceivedAction["payload"]
>(DEMAND_COMPARISON_SESSION_DATA_RECEIVED);

export const dwellTimeDataReceived =
    createAction<DwellTimeDataReceivedAction["payload"]>(DWELL_TIME_DATA_RECEIVED);

export const comparisonDwellTimeDataReceived = createAction<
    ComparisonDwellTimeDataReceivedAction["payload"]
>(COMPARISON_DWELL_TIME_DATA_RECEIVED);

export const getDemandChartAggregateData = createAction<
    GetDemandChartAggregateDataAction["payload"]
>(GET_DEMAND_CHART_AGGREGATE_DATA);

export const getDemandComparisonChartAggregateData = createAction<
    GetDemandComparisonChartAggregateDataAction["payload"]
>(GET_DEMAND_COMPARISON_CHART_AGGREGATE_DATA);

export const getAggregatedDwellTimeData = createAction<GetAggregatedDwellTimeDataAction["payload"]>(
    GET_AGGREGATED_DWELL_TIME_DATA
);

export const getAggregatedDemandMapData = createAction<GetAggregatedDemandMapDataAction["payload"]>(
    GET_AGGREGATED_DEMAND_MAP_DATA
);

export const toggleHistoricalOccupancy = createAction<ToggleHistoricalOccupancy["payload"]>(
    TOGGLE_HISTORICAL_OCCUPANCY
);

export const getHistoricalOccupancy =
    createAction<GetHistoricalOccupancy["payload"]>(GET_HISTORICAL_OCCUPANCY);

export const historicalOccupancyReceived = createAction<HistoricalOccupancyReceived["payload"]>(
    HISTORICAL_OCCUPANCY_RECEIVED
);

export const selectedHistoricalOccupancyRange = createAction<
    SelectedHistoricalOccupancyRange["payload"]
>(SELECTED_HISTORICAL_OCCUPANCY_RANGE);

export const getAverageOccupancyPercent = createAction<GetAverageOccupancyPercent["payload"]>(
    GET_AVERAGE_OCCUPANCY_PERCENT
);
